export default "/static/images/build_roof_12.png?4fa8f4177510d4b9e3f8d60f17c33209";